query GetNewsItems(
  $page: Int
  $limit: Int
  $search: String
  $searchFilter: NewsItemsSearchEnum!
) {
  newsItems(
    page: $page
    limit: $limit
    search: $search
    searchFilter: $searchFilter
  ) {
    collection {
      id
      eventType {
        id
        name
      }
      title
      date
      tags
      url
      showFrom
      showTo
      order
      active
    }
    metadata {
      totalPages
      totalCount
      currentPage
      limitValue
    }
  }
}
